import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import classnames from 'classnames';
import {rem} from "polished";

import { Input } from './';
import { formatDate } from '../../../../utils/date-utils';
import Calendar from '../calendar/Calendar';
import withSingleSelection from '../calendar/withSingleSelection';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons/Icons';
import colors from '../../../../utils/colors';
import {StyledInputWrapper, StyledError} from './ui/';

const CalendarWithSingleSelection = withSingleSelection(Calendar);
const StyledWrap = styled.div`
  position: relative;

  > .error {
    background: ${colors.BRAND_RED_LIGHTEST};  
  }
`;
const CalendarWrap = styled.div`
  display: none;
  &.visible {
    display: block;
  }
`;

class DatePickerInput extends Component {
  state = {
    selectedDate: moment().startOf('day'),
    calendarVisible: false,
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.value) {
      this.setState({
        selectedDate: nextProps.value
      });
    }
    else {
      this.setState({
        selectedDate: moment()
      }, this.onDateSelected(this.state.selectedDate));
    }
  }

  componentDidMount = () => {
    this.props.onChange({
      target: this.dateInput.name,
      value: this.state.selectedDate,
    });
  }

  componentWillUnmount = () => {
    document.removeEventListener('click', this.hideCalendar);
  }

  onDateFocus = (event) => {
    if(this.state.calendarVisible) return;
    this.showCalendar();
  }

  onDateSelected = (date) => {
    this.setState({
      selectedDate: date,
      calendarVisible: false,
    });
    this.props.onChange({
      target: {
        name: this.dateInput.name,
        value: date,
      }
    });
    document.removeEventListener('click', this.hideCalendar);
  }

  hideCalendar = (event) => {
    if(!this.state.calendarVisible) return;
    document.removeEventListener('click', this.hideCalendar);
    this.setState({
      calendarVisible: false
    });
  }

  showCalendar = (event) => {
    if(this.state.calendarVisible) return;
    this.setState({
      calendarVisible: true
    });
    setTimeout(() => {
      document.addEventListener('click', this.hideCalendar);
    }, 150);
  }

  onWrapClick = (event) => {
    if(!this.state.calendarVisible) return;
    event.stopPropagation();
    event.nativeEvent.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }

  render() {
    const {
      onChange,
      name,
      error,
      errorMessage,
      firstPossibleDate,
      lastPossibleDate,
      ...rest,
    } = this.props;

    const strict = this.props.strict ? this.props.strict : false;
    const half = this.props.half ? this.props.half : false;

    const calendarClass = classnames({
      visible: this.state.calendarVisible
    });

    const inputClass = classnames("", {
      'error': error,
    });

    return (
      <StyledWrap>
        <Input
          readOnly
          {...rest}
          half={half}
          name={name}
          value={formatDate(this.state.selectedDate)}
          innerRef={(input) => { this.dateInput = input; }}
          onFocus={this.onDateFocus}
          onChange={onChange}
          onClick={this.showCalendar}
        >
        <Icon icon={ICONS.DATE} width={rem("24px")} height={rem("26px")} fill={colors.BRAND_RED} stroke={colors.TRANSPARENT} strokeWidth={1} />
        </Input>
        <CalendarWrap className={calendarClass} onClick={this.onWrapClick}>
          <CalendarWithSingleSelection
            strict={strict}
            firstPossibleDate={firstPossibleDate}
            lastPossibleDate={lastPossibleDate}
            selectedDate={this.state.selectedDate}
            onDateSelected={this.onDateSelected}
          />
        </CalendarWrap>

        {error && !!errorMessage && (
          <StyledInputWrapper className={inputClass}>
            <StyledError dangerouslySetInnerHTML={{__html : errorMessage}} />
          </StyledInputWrapper>
        )}
      </StyledWrap>
    );
  }
}

export default DatePickerInput;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/DatePickerInput.js